"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _List = _interopRequireDefault(require("@mui/material/List"));
var _fonts = _interopRequireDefault(require("../theme/fonts"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 
 * @param {*} props 
 * @returns 
 */
var StyledList = function StyledList(props) {
  var styles = _objectSpread({
    "&.MuiList-root": {
      fontFamily: _fonts["default"].type.medium,
      minWidth: 250
    },
    "&.MuiList-padding": {
      paddingBottom: 8
    }
  }, props.style);
  return /*#__PURE__*/_react["default"].createElement(_List["default"], (0, _extends2["default"])({}, props, {
    sx: styles
  }), props.children);
};
var _default = exports["default"] = StyledList;